import AOS from "aos/dist/aos.js";
import "aos/dist/aos.css";
$(function () {
  AOS.init();
});
